function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 64,
  r: 62,
  fill: "#FFF8F8"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#clock_svg__filter0_d_807_0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 64,
  r: 52,
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M68 80.334c10.125 0 18.333-8.209 18.333-18.334S78.125 43.667 68 43.667c-10.125 0-18.333 8.208-18.333 18.333 0 10.126 8.208 18.334 18.333 18.334z",
  stroke: "#FB4246",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M68 51v11l7.333 3.667",
  stroke: "#FB4246",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "clock_svg__filter0_d_807_0",
  x: 0,
  y: 0,
  width: 134,
  height: 134,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.443137 0 0 0 0 0.454902 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_807_0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_807_0",
  result: "shape"
})));

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgClock;